import constants from "../constants";

const { INIT_BACNET_ADDRESSES_STORE, UPDATE_BACNET_ADDRESSES_STORE } = constants;

export const initBacnetAddressesStore = (bacnetAddresses) => ({
  type: INIT_BACNET_ADDRESSES_STORE,
  bacnetAddresses,
});

export const updateBacnetAddressesStore = (updates) => ({
  type: UPDATE_BACNET_ADDRESSES_STORE,
  updates,
});
